<template>
  <mds-layout-grid :class="$style['fee-schedule-list-panel']">
    <div :class="$style['fee-schedule-list-panel__content']">
      <FeeScheduleListPanelHeader
        :title="translate('assetBasedFee')"
        :description="translate('actualWorkflowDescription')"
        :primary-button-config="primaryButtonConfig"
        @click="closeFeeSchedulePanel"
      />
      <slot></slot>
    </div>
  </mds-layout-grid>
</template>

<script>
import { MdsLayoutGrid } from '@mds/layout-grid';
import FeeScheduleListPanelHeader from '../../common/FeeScheduleListPanelHeader';

export default {
  name: 'fee-schedule-list-panel',
  components: {
    MdsLayoutGrid,
    FeeScheduleListPanelHeader,
  },
  inject: ['translate'],
  computed: {
    primaryButtonConfig() {
      return {
        text: this.translate('close'),
        visible: true,
        disabled: false,
      };
    },
  },
  methods: {
    closeFeeSchedulePanel(e) {
      this.$emit('close', e);
    },
  },
};
</script>

<style lang="scss" module>
@import '@mds/constants';
@import '@mds/typography';

.fee-schedule-list-panel {
  @include mds-body-text-m();
  min-width: 800px;
  margin: 0 auto;
  margin-bottom: $mds-space-2-and-a-half-x;
}
</style>
